import React, { Component } from 'react';

class Image extends Component {
  render() {
    const { style, className, imageStyle, media } = this.props;

    let uri = typeof media !== "undefined" ? media.uri : this.props.url;
    const alt = typeof media !== "undefined" ? media.alt : this.props.alt;
    
    if (typeof imageStyle !== "undefined") {
      uri = uri.replace('/files/styles/1200/public/', '/files/styles/' + imageStyle + '/public/');
    } else if (window.innerWidth < 600) {
      uri = uri.replace("files/styles/1200/public/","files/styles/600/public/");
    } else if (window.innerWidth < 900) {
      uri = uri.replace("files/styles/1200/public/","files/styles/900/public/");
    }

    if (alt === null) {
      return (
        <img className={className} src={uri} alt="" style={{...style,width: "100%"}} />
      );
    } else {
      return (
        <img className={className} src={uri} alt={alt} style={{...style,width: "100%"}} />
      );
    }
  }   
}

export default Image ;
